import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createProviderReferral, CreateProviderReferralInput, getProviderReferralById, getProviderReferrals } from '@uplift/api';

export const signOnBonusProviderReferralKeys = {
  all: [ 'providerReferrals' ] as const,
  byProvider: (providerId: string) => [ ...signOnBonusProviderReferralKeys.all, providerId ] as const,
  byId: (providerId: string, referralId: string) => [ ...signOnBonusProviderReferralKeys.all, providerId, referralId ] as const,
};

export const useProviderReferralsQuery = (providerId: string) => {
  return useQuery({
    queryKey: signOnBonusProviderReferralKeys.byProvider(providerId),
    queryFn: () => getProviderReferrals(providerId),
  });
};

export const useProviderReferralQuery = (providerId: string, referralId: string) => {
  return useQuery({
    queryKey: signOnBonusProviderReferralKeys.byId(providerId, referralId),
    queryFn: async () => {
      const response = await getProviderReferralById(providerId, referralId);

      return response.data;
    },
  });
};

export const useCreateProviderReferralMutation = (providerId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateProviderReferralInput) => {
      return createProviderReferral(providerId, data);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'provider', providerId, 'activation', 'events' ] });
    },
  });
};
